export enum ActivityType {
  OpenEnded = 'OPEN_ENDED',
  OEVocabLearning = 'OPEN_ENDED_WITH_VOCAB_LEARNING',
  OEScaffolding = 'OPEN_ENDED_WITH_SCAFFOLDING',
  OESimple = 'OPEN_ENDED_SIMPLE',
  OEPreLearning = 'OPEN_ENDED_PRE_LEARNING',
  Modular = 'MODULAR',
  VLMultipleChoices = 'VOCAB_LEARNING_MULTIPLE_CHOICES',
  ModelAnswerAndVocabPronunciationPractice = 'MODEL_ANSWER_AND_VOCAB_PRONUNCIATION_PRACTICE',
  SimpleQuiz = 'SIMPLE_QUIZ',
  CreateYourOwnResponse = 'CREATE_YOUR_OWN_RESPONSE',
  SimpleTwoWay = 'SIMPLE_TWO_WAY',
  Writing = 'WRITING',
}

export enum HintType {
  TalkingPoint = 'TALKING_POINT',
  ModelAnswer = 'MODEL_ANSWER',
  ResponsePattern = 'RESPONSE_PATTERN',
  VocabChoice = 'VOCAB_CHOICE',
  OnloadYoutubeVideo = 'ONLOAD_YOUTUBE_VIDEO',
}

export interface Hint {
  id: string;
  type: HintType;
  content: string;
}
